import { render, staticRenderFns } from "./HomeHotRecommendGroup.vue?vue&type=template&id=c4fa2fc0&"
import script from "./HomeHotRecommendGroup.vue?vue&type=script&lang=js&"
export * from "./HomeHotRecommendGroup.vue?vue&type=script&lang=js&"
import style0 from "./HomeHotRecommendGroup.vue?vue&type=style&index=0&id=c4fa2fc0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports